import script from "./AssessmentGovernanceRecovery.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentGovernanceRecovery.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentGovernanceRecovery.vue?vue&type=style&index=0&id=fd4a25c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd4a25c0"]])

export default __exports__